// Check if the class has already been defined to prevent re-declaration
if (!customElements.get('product-reviews')) {
  class ProductReviews extends HTMLElement {
    constructor() {
      super();
      console.log('ProductReviews constructor initialized');
      
      this.reviewsList = this.querySelector('.product-reviews__list');
      this.loadMoreButton = this.querySelector('.product-reviews__load-more');
      this.loadingElement = this.querySelector('.product-reviews__loading');
      this.productId = this.dataset.productId || ''; // Get product ID from data attribute
      this.locale = this.dataset.locale || Shopify?.locale || 'en'; // Get locale from data attribute or Shopify
      
      console.log('Product ID from data attribute (Reviews):', this.productId);
      console.log('Locale from data attribute or Shopify:', this.locale);
      
      this.currentPage = 1;
      this.reviewsPerPage = 30;//salah revies per page
      this.allReviews = [];
      this.displayedReviews = 0;
      this.totalReviews = 0;
      
      if (this.loadMoreButton) {
        this.loadMoreButton.addEventListener('click', this.loadMoreReviews.bind(this));
      }
      
      // Log DOM elements to debug
      console.log('Reviews list element:', this.reviewsList);
      console.log('Load more button:', this.loadMoreButton);
      console.log('Loading element:', this.loadingElement);
      
      this.init();
    }
  
  async init() {
    console.log('Initializing product reviews component');
    try {
      await this.loadReviews();
      this.renderReviews();
      this.updateLoadMoreButton();
      console.log('Product reviews component initialized successfully');
    } catch (error) {
      console.error('Error initializing reviews:', error);
      this.showEmptyState();
    }
  }
  
  async loadReviews() {
    console.log('loadReviews method called');
    
    if (!this.productId) {
      console.error('No product ID provided for reviews');
      this.showEmptyState();
      return;
    }
    
    console.log('Loading reviews for product ID:', this.productId);
    
    // Get the current locale from the component or Shopify
    const currentLocale = (this.locale || Shopify?.locale || 'en').toUpperCase();
    console.log('Current locale for reviews:', currentLocale);
    
    // Get the URLs from the JSON data in the page
    const urlsElement = document.getElementById('product-reviews-urls');
    let urls = {};
    
    if (urlsElement) {
      try {
        urls = JSON.parse(urlsElement.textContent);
        console.log('Found review URLs in JSON element:', urls);
      } catch (error) {
        console.error('Error parsing review URLs:', error);
      }
    } else {
      console.warn('No product-reviews-urls element found');
    }
    
    // Log all available URLs for debugging
    console.log('Available URLs from JSON:');
    for (const [key, url] of Object.entries(urls)) {
      console.log(`${key}: ${url}`);
    }
    
    // Build the direct file URL based on locale and product ID
    const localeKey = currentLocale.toLowerCase();
    const directFileUrl = `/assets/${currentLocale}_${this.productId}.csv`;
    console.log('Attempting to load direct file URL:', directFileUrl);
    
    // Try to load reviews directly using the locale and product ID pattern
    try {
      console.log('Trying to load locale-specific file:', directFileUrl);
      
      const response = await fetch(directFileUrl);
      console.log('Direct file response status:', response.status);
      
      if (response.ok) {
        console.log(`Successfully loaded ${currentLocale} reviews directly`);
        const csvText = await response.text();
        console.log('CSV text first 100 chars:', csvText.substring(0, 100));
        this.parseReviews(csvText);
        return;
      } else {
        console.warn(`Direct ${currentLocale} reviews file not found:`, response.status);
      }
    } catch (error) {
      console.error(`Error loading direct ${currentLocale} reviews:`, error);
    }
    
    // If direct file fails, try using the URL from the JSON
    if (urls[localeKey]) {
      try {
        console.log('Trying to load locale-specific file from JSON:', urls[localeKey]);
        
        const response = await fetch(urls[localeKey]);
        console.log('JSON URL response status:', response.status);
        
        if (response.ok) {
          console.log(`Successfully loaded ${localeKey} reviews from JSON URL`);
          const csvText = await response.text();
          console.log('CSV text first 100 chars:', csvText.substring(0, 100));
          this.parseReviews(csvText);
          return;
        } else {
          console.warn(`${localeKey} reviews file from JSON not found:`, response.status);
        }
      } catch (error) {
        console.error(`Error loading ${localeKey} reviews from JSON:`, error);
      }
    } else {
      console.warn(`No URL found in JSON for locale: ${localeKey}`);
    }
    
    // If locale-specific file fails, fall back to English
    if (currentLocale !== 'EN') {
      // Try direct English file
      const enDirectFileUrl = `/assets/EN_${this.productId}.csv`;
      console.log('Falling back to direct English file:', enDirectFileUrl);
      
      try {
        const response = await fetch(enDirectFileUrl);
        console.log('English direct file response status:', response.status);
        
        if (response.ok) {
          console.log('Successfully loaded English fallback reviews directly');
          const csvText = await response.text();
          console.log('English CSV text first 100 chars:', csvText.substring(0, 100));
          this.parseReviews(csvText);
          return;
        } else {
          console.warn('English direct fallback reviews file not found:', response.status);
        }
      } catch (error) {
        console.error('Error loading English direct fallback reviews:', error);
      }
      
      // Try English from JSON
      if (urls['en']) {
        try {
          console.log('Falling back to English file from JSON:', urls['en']);
          
          const response = await fetch(urls['en']);
          console.log('English JSON fallback response status:', response.status);
          
          if (response.ok) {
            console.log('Successfully loaded English fallback reviews from JSON');
            const csvText = await response.text();
            console.log('English CSV text first 100 chars:', csvText.substring(0, 100));
            this.parseReviews(csvText);
            return;
          } else {
            console.warn('English JSON fallback reviews file not found:', response.status);
          }
        } catch (error) {
          console.error('Error loading English JSON fallback reviews:', error);
        }
      }
    }
    
    // Try the legacy file as a last resort
    if (urls['legacy']) {
      try {
        console.log('Trying legacy file as last resort:', urls['legacy']);
        
        const response = await fetch(urls['legacy']);
        console.log('Legacy file response status:', response.status);
        
        if (response.ok) {
          console.log('Successfully loaded legacy reviews file');
          const csvText = await response.text();
          console.log('Legacy CSV text first 100 chars:', csvText.substring(0, 100));
          this.parseReviews(csvText);
          return;
        } else {
          console.warn('Legacy reviews file not found:', response.status);
        }
      } catch (error) {
        console.error('Error loading legacy reviews:', error);
      }
    }
    
    // If all attempts fail, show empty state
    console.error('Could not load any reviews, showing empty state');
    this.showEmptyState();
  }
  
  parseReviews(csvText) {
    console.log('Parsing CSV reviews');
    
    // Split the CSV into lines
    const lines = csvText.split('\n');
    console.log(`CSV has ${lines.length} lines`);
    
    if (lines.length === 0) {
      console.error('CSV file is empty');
      return;
    }
    
    // Get the header line and parse column names
    const headers = this.parseCSVLine(lines[0]);
    console.log('CSV headers:', headers);
    
    // Parse each review line
    this.allReviews = [];
    
    // Join lines that are part of the same record (handling multi-line fields)
    let joinedLines = [];
    let currentLine = '';
    let inQuotes = false;
    
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      
      // Skip empty lines
      if (!line.trim() && currentLine === '') continue;
      
      // Count quotes in the line to determine if we're inside a quoted field
      // We need to count actual quotes, not escaped quotes
      for (let j = 0; j < line.length; j++) {
        if (line[j] === '"' && (j === 0 || line[j-1] !== '\\')) {
          inQuotes = !inQuotes;
        }
      }
      
      if (currentLine === '') {
        currentLine = line;
      } else {
        currentLine += '\n' + line;
      }
      
      // If we're not inside quotes and the line has content, it's a complete record
      if (!inQuotes && currentLine.trim()) {
        joinedLines.push(currentLine);
        currentLine = '';
      }
    }
    
    // Add the last line if there's anything left
    if (currentLine.trim()) {
      joinedLines.push(currentLine);
    }
    
    console.log(`Joined into ${joinedLines.length} complete records`);
    
    // Process each joined line
    for (let i = 1; i < joinedLines.length; i++) {
      if (!joinedLines[i].trim()) continue;
      
      try {
        // Handle commas within quoted fields
        const values = this.parseCSVLine(joinedLines[i]);
        /*
        if (values.length !== headers.length) {
          console.warn(`Skipping malformed review line ${i}: values=${values.length}, headers=${headers.length}, line=${joinedLines[i].substring(0, 50)}...`);
          continue;
        }*/
        
        // Create review object from headers and values
        const review = {};
        headers.forEach((header, index) => {
          // Clean up the value (remove extra newlines, etc.)
          let value = values[index];
          if (typeof value === 'string') {
            // Preserve some newlines in the body field
            if (header === 'body') {
              value = value.replace(/\n{3,}/g, '\n\n').trim();
            } else {
              value = value.replace(/\n+/g, ' ').trim();
            }
          }
          review[header] = value;
        });
        
        // For the new CSV format, we need to handle "Unpublished" as "Published"
        // since that's how the reviews are marked in the provided CSV
        if (review.state && (review.state.toLowerCase() === 'published' || review.state.toLowerCase() === 'unpublished')) {
          console.log(`Adding review: ${review.author} - ${review.title?.substring(0, 30)}`);
          this.allReviews.push(review);
        }
      } catch (error) {
        console.error(`Error parsing review line ${i}:`, error);
      }
    }
    
    console.log(`Successfully parsed ${this.allReviews.length} reviews`);
    
    // No sorting - keep reviews in original order from CSV
    
    this.totalReviews = this.allReviews.length;
    console.log(`Total reviews after sorting: ${this.totalReviews}`);
  }
  
  parseCSVLine(line) {
    const result = [];
    let current = '';
    let inQuotes = false;
    
    for (let i = 0; i < line.length; i++) {
      const char = line[i];
      
      if (char === '"') {
        // Check if this is an escaped quote (""") inside a quoted field
        if (inQuotes && i + 1 < line.length && line[i + 1] === '"') {
          current += '"';
          i++; // Skip the next quote
        } else {
          // Toggle quote state
          inQuotes = !inQuotes;
        }
      } else if (char === ',' && !inQuotes) {
        // End of field
        result.push(this.cleanQuotes(current));
        current = '';
      } else {
        current += char;
      }
    }
    
    // Add the last field
    result.push(this.cleanQuotes(current));
    
    return result;
  }
  
  cleanQuotes(str) {
    // Remove surrounding quotes and handle escaped quotes
    if (str.startsWith('"') && str.endsWith('"')) {
      str = str.substring(1, str.length - 1);
    }
    return str.replace(/""/g, '"');
  }
  
  renderReviews() {
    console.log('Rendering reviews');
    
    if (this.loadingElement) {
      this.loadingElement.style.display = 'none';
    }
    
    if (this.allReviews.length === 0) {
      console.log('No reviews to display');
      this.showEmptyState();
      return;
    }
    
    console.log('Total reviews:', this.allReviews.length);
    
    // When loading more reviews, we'll clear the list and re-render all reviews
    // to ensure they maintain the original order from the CSV file
    if (this.displayedReviews > 0) {
      // Remove all review items but keep the loading element
      const reviewItems = this.reviewsList.querySelectorAll('.product-reviews__item');
      reviewItems.forEach(item => item.remove());
    }
    
    const endIndex = Math.min(this.reviewsPerPage * this.currentPage, this.allReviews.length);
    
    console.log(`Displaying reviews from 0 to ${endIndex}`);
    
    // Always render from the beginning to maintain original order
    for (let i = 0; i < endIndex; i++) {
      const review = this.allReviews[i];
      console.log(`Rendering review ${i}:`, review.title);
      const reviewElement = this.createReviewElement(review);
      this.reviewsList.appendChild(reviewElement);
    }
    
    this.displayedReviews = endIndex;
    console.log('Updated displayedReviews to:', this.displayedReviews);
  }
  
  createReviewElement(review) {
    console.log('Creating review element for:', review.title);
    const reviewElement = document.createElement('div');
    reviewElement.classList.add('product-reviews__item');
    
    // Parse image URLs (they might be comma-separated)
    let imageUrls = [];
    if (review.imageUrl) {
      imageUrls = review.imageUrl.split(',').map(url => url.trim());
    }
    
    // Extract the actual title from the full title field
    // The title often contains "X.X out of 5 stars" followed by newlines and then the actual title
    let cleanTitle = '';
    if (review.title) {
      // Split by newlines and filter out empty lines
      const titleParts = review.title.split('\n').filter(part => part.trim());
      
      // The last non-empty part is usually the actual title
      if (titleParts.length > 0) {
        // Get the last part and trim it
        cleanTitle = titleParts[titleParts.length - 1].trim();
        
        // If it starts with spaces or tabs, clean those up too
        cleanTitle = cleanTitle.replace(/^\s+/, '');
        
        console.log('Extracted clean title:', cleanTitle);
      } else {
        // If we couldn't parse it properly, just use the original title
        cleanTitle = review.title;
      }
    }
    
    // Create review HTML with images at the top
    reviewElement.innerHTML = `
      ${imageUrls.length > 0 ? `
        <div class="product-reviews__images">
          ${imageUrls.map(url => `
            <div class="product-reviews__image-container">
              <img src="${url}" alt="Review image" class="product-reviews__image">
            </div>
          `).join('')}
        </div>
      ` : ''}
      
      <div class="product-reviews__info">
        <div class="product-reviews__author-name">${review.author || 'Anonymous'}</div>
        <div class="product-reviews__rating">
          ${this.createStarRating(parseFloat(review.rating))}
        </div>
        ${review.verified_purchase ? `
          <div class="product-reviews__verified">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
            </svg>
            Verified Purchase
          </div>
        ` : ''}
        ${cleanTitle ? `<h4 class="product-reviews__title">${cleanTitle}</h4>` : ''}
        <div class="product-reviews__content">
          ${review.body || ''}
        </div>
      </div>
    `;
    
    return reviewElement;
  }
  
  getAuthorImage(review) {
    // If there's a specific author image field, use that
    if (review.author_image) return review.author_image;
    
    // Otherwise generate a placeholder based on the author's name
    return `https://ui-avatars.com/api/?name=${encodeURIComponent(review.author || 'A')}&background=random`;
  }
  
  createStarRating(rating) {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
    
    return `
      <div class="rating" role="img" aria-label="${rating} out of 5 stars">
        ${Array(fullStars).fill('<span class="star-full" style="color: gold;">★</span>').join('')}
        ${hasHalfStar ? '<span class="star-half" style="color: gold;">★</span>' : ''}
        ${Array(emptyStars).fill('<span class="star-empty" style="color: #ccc;">☆</span>').join('')}
      </div>
    `;
  }
  
  loadMoreReviews() {
    console.log('Load more button clicked');
    this.currentPage++;
    this.renderReviews();
    this.updateLoadMoreButton();
  }
  
  updateLoadMoreButton() {
    console.log('Updating load more button');
    console.log('displayedReviews:', this.displayedReviews);
    console.log('totalReviews:', this.totalReviews);
    
    if (this.loadMoreButton) {
      console.log('Load more button found:', this.loadMoreButton);
      if (this.displayedReviews < this.totalReviews) {
        console.log('Showing load more button');
        this.loadMoreButton.style.display = 'block';
      } else {
        console.log('Hiding load more button');
        this.loadMoreButton.style.display = 'none';
      }
    } else {
      console.warn('Load more button not found');
    }
  }
  
  showEmptyState() {
    console.log('Showing empty state');
    
    if (this.loadingElement) {
      this.loadingElement.style.display = 'none';
    }
    
    // Check if reviewsList exists before trying to modify it
    if (this.reviewsList) {
      const emptyElement = document.createElement('div');
      emptyElement.classList.add('product-reviews__empty');
      emptyElement.textContent = 'No reviews yet for this product';
      this.reviewsList.innerHTML = '';
      this.reviewsList.appendChild(emptyElement);
    } else {
      console.warn('Cannot show empty state: reviewsList element not found');
    }
    
    if (this.loadMoreButton) {
      this.loadMoreButton.style.display = 'none';
    }
  }
  
  // getLocaleDateFormat method removed as it's no longer needed
  
  // Date formatting removed as it's no longer needed
  
  // Translations removed as requested
}

  // Define the custom element
  customElements.define('product-reviews', ProductReviews);
  console.log('ProductReviews custom element defined');

  // Initialize reviews when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    console.log('DOMContentLoaded event fired');
    const reviewsElements = document.querySelectorAll('product-reviews');
    console.log('Found product-reviews elements:', reviewsElements.length);
    
    reviewsElements.forEach(element => {
      console.log('Setting up product-reviews element:', element);
      // Set translation attributes from the current locale
      // No need to set translation attributes
    });
  });

  // Use a mutation observer to detect when the custom elements are added to the DOM
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if the node itself is a product-reviews element
            if (node.nodeName.toLowerCase() === 'product-reviews' && !node._initialized) {
              console.log('Found new product-reviews element via mutation observer:', node);
              
              // Make sure the element has the required child elements before initializing
              if (!node.querySelector('.product-reviews__list')) {
                console.log('Adding required child elements to product-reviews element');
                
                // Add the required child elements
                const listElement = document.createElement('div');
                listElement.classList.add('product-reviews__list');
                
                const loadingElement = document.createElement('div');
                loadingElement.classList.add('product-reviews__loading');
                loadingElement.innerHTML = `
                  <div class="loading-overlay__spinner">
                    <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                      <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                    </svg>
                  </div>
                `;
                
                const actionsElement = document.createElement('div');
                actionsElement.classList.add('product-reviews__actions');
                actionsElement.innerHTML = `
                  <button type="button" class="product-reviews__load-more button button--secondary" style="display: none;">
                    Load more reviews
                  </button>
                `;
                
                listElement.appendChild(loadingElement);
                node.appendChild(listElement);
                node.appendChild(actionsElement);
              }
              
              node._initialized = true;
              // Force constructor to run again
              new ProductReviews(node);
            }
            
            // Check for product-reviews elements within the added node
            if (node.querySelectorAll) {
              const reviewsElements = node.querySelectorAll('product-reviews');
              if (reviewsElements.length > 0) {
                console.log('Found product-reviews elements within added node:', reviewsElements.length);
              }
              
              reviewsElements.forEach(element => {
                if (!element._initialized) {
                  console.log('Initializing nested product-reviews element:', element);
                  
                  // Make sure the element has the required child elements before initializing
                  if (!element.querySelector('.product-reviews__list')) {
                    console.log('Adding required child elements to nested product-reviews element');
                    
                    // Add the required child elements
                    const listElement = document.createElement('div');
                    listElement.classList.add('product-reviews__list');
                    
                    const loadingElement = document.createElement('div');
                    loadingElement.classList.add('product-reviews__loading');
                    loadingElement.innerHTML = `
                      <div class="loading-overlay__spinner">
                        <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                        </svg>
                      </div>
                    `;
                    
                    const actionsElement = document.createElement('div');
                    actionsElement.classList.add('product-reviews__actions');
                    actionsElement.innerHTML = `
                      <button type="button" class="product-reviews__load-more button button--secondary" style="display: none;">
                        Load more reviews
                      </button>
                    `;
                    
                    listElement.appendChild(loadingElement);
                    element.appendChild(listElement);
                    element.appendChild(actionsElement);
                  }
                  
                  element._initialized = true;
                  // Force constructor to run
                  new ProductReviews(element);
                }
              });
            }
          }
        });
      }
    });
  });

  console.log('Setting up mutation observer for product-reviews');
  // Start observing the document body for changes
  observer.observe(document.body, { childList: true, subtree: true });

  // Immediate check for any existing elements
  console.log('Checking for existing product-reviews elements');
  const existingElements = document.querySelectorAll('product-reviews');
  console.log('Found existing product-reviews elements:', existingElements.length);
  existingElements.forEach(element => {
    if (!element._initialized) {
      console.log('Initializing existing product-reviews element:', element);
      
      // Make sure the element has the required child elements before initializing
      if (!element.querySelector('.product-reviews__list')) {
        console.log('Adding required child elements to existing product-reviews element');
        
        // Add the required child elements
        const listElement = document.createElement('div');
        listElement.classList.add('product-reviews__list');
        
        const loadingElement = document.createElement('div');
        loadingElement.classList.add('product-reviews__loading');
        loadingElement.innerHTML = `
          <div class="loading-overlay__spinner">
            <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>
        `;
        
        const actionsElement = document.createElement('div');
        actionsElement.classList.add('product-reviews__actions');
        actionsElement.innerHTML = `
          <button type="button" class="product-reviews__load-more button button--secondary" style="display: none;">
            Load more reviews
          </button>
        `;
        
        listElement.appendChild(loadingElement);
        element.appendChild(listElement);
        element.appendChild(actionsElement);
      }
      
      element._initialized = true;
      // Force constructor to run
      new ProductReviews(element);
    }
  });

} // Close the if (!customElements.get('product-reviews')) conditional